<template>
  <div class="home-box">
    <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
   
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Trust Sheet</h3>
        <v-spacer></v-spacer>
        <AutocompleteSearch @changeData="clubId = $event" :storeLink="'member/getRoleClubs'" :setectVale="clubId"
          :itemText="'name'" :label="'Select Club'" />
      </v-card-title>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-list v-if="!loading">
            <v-list-item v-for="(item, index) in list" :key="index">
              <v-list-item-action>
                <v-icon large :color="'orange'">mdi-information</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item>{{ item.title }}</v-list-item>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title style="text-align: right;">
                  Target :
                  <v-chip small class="ma-1" dark :color="'green'">
                  {{item.target }}
                </v-chip>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content>
                <v-list-item-title style="text-align: right;">
                
                 <v-chip small class="ma-1" dark :color="getStatusColor()" v-if="item.trust_sheets">
                  Promise :
                {{ item.trust_sheets.promise }}</v-chip>
                <v-btn v-else
                    fab
                    small
                    depressed
                    class="white--text"
                    color="indigo"
                    title="Add"
                 @click="AddPromise(item.id, item.target)"
                >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list v-if="!list">
            <v-list-item-content>
              <v-list-item-title>Trust sheet not found!</v-list-item-title>
            </v-list-item-content>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" color="orange" @classSnackbar="closeSnackbar" />
    <AddPromise
      :title="'Update Promise'"
      :color="'gray'"
      :confirmCommentOpen="confirmCommentOpen"
      @cancelPromiseConfirm="cancelPromiseConfirm()"
      @confirmPromise="confirmPromise($event)"
    ></AddPromise>
  </div>
 
</template>


<script>
import MonthsList from "@/utility/months.json";
import { TrustSheetService } from "../../services/trust-sheet.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import AddPromise from "@/components/shared/AddPromise";

export default {
  name: "ActivityList",
  components: { Snackbars, AutocompleteSearch, AddPromise, Alert },

  data: function () {
    return {
      loading: false,
      filterBtnTTip: false,
      month: "",
      months: MonthsList,
      list: [],
      clubId: "",
      role: localStorage.getItem("role"),
      errors: null,
      successMsg: "",
      snackbar: false,
      promiseValue: null,
      confirmCommentOpen: false,
      activity_id:null,
      promise:null,
      activityTarget:0
    };
  },

  mounted() {
    this.$store.dispatch("auth/getProfile");

    localStorage.removeItem("maf_contribution_uuid");
    localStorage.removeItem("mjf_contribution_uuid");
    localStorage.removeItem("service_project_uuid");
    if (this.role == 'CLUB_PRESIDENT' || this.role == 'CLUB_SECRETARY' || this.role == 'CLUB_TREASURER' || this.role == 'CLUB_ADMINISTRATOR') {
      this.clubId = localStorage.getItem("club_id");
      localStorage.removeItem("trust_sheet_club");
    } else {
      this.clubId = localStorage.getItem("trust_sheet_club") ?? localStorage.getItem("club_id");
      localStorage.setItem("trust_sheet_club", this.clubId);
    }

    this.loadTaskList();

  },

  watch: {
    clubId(val) {
      if (this.role !== 'CLUB_PRESIDENT' && this.role !== 'CLUB_SECRETARY' && this.role !== 'CLUB_TREASURER' && this.role !== 'CLUB_ADMINISTRATOR') {
        localStorage.setItem("trust_sheet_club", val);
      }
      this.loadTaskList();
    }
  },

  methods: {
    getStatusColor() {
      let bgColor = "blue";
      return bgColor;
    },

    loadTaskList() {
      if (this.clubId) {
        this.loading = true;
        TrustSheetService.getClubTrustSheet(this.clubId)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.list = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            this.list = [];
          });
      }

    },

    AddPromise(activityId, target){
      this.activity_id = activityId;
      this.confirmCommentOpen = true;
      this.activityTarget = target;

    },

    updatePromise() {
      this.errors = null;
      if (this.activity_id && this.promise) {
        this.loading = true;
        this.errors = null;
        this.confirmCommentOpen = false;
        TrustSheetService.update({'trust_sheet_activity_id':this.activity_id, 'promise':this.promise})
          .then((response) => {
            if(response){
              this.loading = false;
              this.activityTarget = 0;
              this.loadTaskList()
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            this.activityTarget =0;
          });

        }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    confirmPromise(value) {
      this.promise = value;
      this.errors = null;
      this.updatePromise();

    },
    cancelPromiseConfirm() {
      this.confirmCommentOpen = false;
      this.activity_id = null;
      this.activityTarget = 0;
      this.errors = null;
    },

    onDismissed() {
      this.errors = null;
    },


   
  },
};
</script>
